// Copyright (c) 2016 Deere & Company

import BasicWarrantyEstimator from '@deere/cps-it.warranty-model-factory/lib/basic-warranty-estimator';
import t from 'tcomb';

const BasicWarrantyEstimatorReport = t.list(BasicWarrantyEstimator, 'Report');

export const getDefaultState = () => new BasicWarrantyEstimatorReport([]);

export default BasicWarrantyEstimatorReport;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/report.js